import { ClassProps } from "@/lib/types/class-props";
import { cx } from "@/lib/utils/className.utils";
import React, { PropsWithChildren } from "react";
import ListTileSkeleton from "./skeletons/list-tile-skeleton";

export type ResponsiveListProps = {
  /**
   * Indicates whether the list should be shown a loading state or not
   */
  loading?: boolean;
} & ClassProps &
  PropsWithChildren;

/**
 * This is a container for list tiles which need to show a loading state when
 * the data is coming from API.
 */
const ResponsiveList = ({
  className,
  loading,
  children,
}: ResponsiveListProps) => {
  return (
    <div className={cx("flex flex-col", className)}>
      {loading
        ? Array.from(Array(10).keys()).map((key) => (
            <ListTileSkeleton key={key} />
          ))
        : children}
    </div>
  );
};

export default ResponsiveList;
